module.exports = __webpack_public_path__ + "img/silhouette.e7262d4a.png";